import { _intl } from "../../../../_metronic/layout/MasterInit";
import { aiApi } from "../../../api";
import { getUserPreferences } from "../../../pages/auth";
import { swalUtil } from "../../../utils/swalUtil";
import { LOADING_END_EVENT, LOADING_START_EVENT } from "../events";
import { REPHRASE_ICON } from "../Icons";
import { createTuneItem } from "../utils";

export class Rephrase {
  static get isTune() {
    return true;
  }

  constructor({ api }) {
    this.api = api;
  }

  getCurrentBlock = () => {
    const currentIndex = this.api.blocks.getCurrentBlockIndex();
    const currentBlock = this.api.blocks.getBlockByIndex(currentIndex);

    return [currentBlock, currentIndex];
  };

  isDisabled = () => {
    const [currentBlock] = this.getCurrentBlock();
    return currentBlock.isEmpty;
  };

  onActivateHandler = async () => {
    const preferences = getUserPreferences();
    try {
      this.api.events.emit(LOADING_START_EVENT);
      const [currentBlock] = this.getCurrentBlock();
      const content = currentBlock.holder.innerText;

      const response = await aiApi.paraphrase({
        text: content,
        language: preferences.default_language,
      });

      this.api.blocks.update(currentBlock.id, {
        text: response.data.content,
      });

      this.api.events.emit(LOADING_END_EVENT);
    } catch (error) {
      this.api.events.emit(LOADING_END_EVENT);
      swalUtil.showErrorMessage(error);
    }
  };

  render() {
    return createTuneItem({
      label: _intl.formatMessage({ id: "editor.rephrase" }),
      icon: REPHRASE_ICON,
      isDisable: this.isDisabled(),
      onActivate: this.onActivateHandler,
    });
  }
}
